import { DndContext, closestCenter, PointerSensor, TouchSensor, KeyboardSensor, useSensor, useSensors } from "@dnd-kit/core";
import { SortableContext, useSortable, arrayMove, verticalListSortingStrategy, sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical } from "lucide-react";

function Item({ id, children, testid }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
  return (
    <li ref={setNodeRef} style={{ transform: CSS.Transform.toString(transform), transition }}
      className={`flex items-start gap-2 rounded-xl ${isDragging ? "relative z-10 shadow-lg ring-2 ring-[color:var(--dcbc-red)]" : ""}`}>
      <button type="button" {...attributes} {...listeners} aria-label="Drag to reorder" data-testid={testid}
        className="mt-3 shrink-0 cursor-grab touch-none rounded-md p-2 text-muted-foreground hover:bg-muted"><GripVertical className="h-5 w-5" /></button>
      <div className="min-w-0 flex-1">{children}</div>
    </li>
  );
}

export function SortableList({ items, onChange, render, testid }) {
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } }),
    useSensor(TouchSensor, { activationConstraint: { delay: 150, tolerance: 5 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }),
  );
  const end = ({ active, over }) => {
    if (!over || active.id === over.id) return;
    onChange(arrayMove(items, items.findIndex((x) => x.id === active.id), items.findIndex((x) => x.id === over.id)));
  };
  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={end}>
      <SortableContext items={items.map((x) => x.id)} strategy={verticalListSortingStrategy}>
        <ul className="space-y-2" data-testid={testid}>{items.map((x) => <Item key={x.id} id={x.id} testid={`drag-${x.id}`}>{render(x)}</Item>)}</ul>
      </SortableContext>
    </DndContext>
  );
}
